
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/banner",
      function () {
        return require("private-next-pages/settings/banner.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/banner"])
      });
    }
  